import { UPDATE_TOP_SKUS_WIDGET } from "./actionTypes"

export const updateTopSkusWidget = data => {
  return {
    type: UPDATE_TOP_SKUS_WIDGET,
    payload: data,
  }
}
